var React = require('react');

function PinMarker (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M3.5 0C1.56 0 0 1.531 0 3.438 0 5.344 3.5 10 3.5 10S7 5.344 7 3.438C7 1.53 5.44 0 3.5 0zm0 5c-.89 0-1.591-.688-1.591-1.563s.7-1.563 1.591-1.563c.89 0 1.591.688 1.591 1.563S4.391 5 3.5 5z"}));
}

PinMarker.defaultProps = {"width":"7","height":"10","viewBox":"0 0 7 10"};

module.exports = PinMarker;

PinMarker.default = PinMarker;
